// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryTemplate_subCatChip__CbL14 {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.4;
  padding: 3px 12px;
  text-decoration: none !important;
}
.CategoryTemplate_subCatChip__CbL14:hover {
  color: #ffffff !important;
}

.CategoryTemplate_attrChip__44Jvt {
  display: inline-block;
  background: #F3EFFD;
  color: #4c2fb3;
  font-weight: 700;
  border-radius: 8px;
  padding: 5px 14px;
  font-size: 12.5px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.15s ease;
}
.CategoryTemplate_attrChip__44Jvt:hover {
  background: #E7DEFB;
}

.CategoryTemplate_actionCell__sM8tv {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 30px;
  white-space: nowrap;
}

.CategoryTemplate_subCategorySlot__22zDt {
  display: inline-flex;
  align-items: center;
  width: 130px;
  min-height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CategoryTemplate/CategoryTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wEAAwE;EACxE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".subCatChip {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  color: #ffffff !important;\n  border: none !important;\n  border-radius: 8px !important;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1.4;\n  padding: 3px 12px;\n  text-decoration: none !important;\n}\n.subCatChip:hover {\n  color: #ffffff !important;\n}\n\n.attrChip {\n  display: inline-block;\n  background: #F3EFFD;\n  color: #4c2fb3;\n  font-weight: 700;\n  border-radius: 8px;\n  padding: 5px 14px;\n  font-size: 12.5px;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.attrChip:hover {\n  background: #E7DEFB;\n}\n\n.actionCell {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 30px;\n  white-space: nowrap;\n}\n\n.subCategorySlot {\n  display: inline-flex;\n  align-items: center;\n  width: 130px;\n  min-height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subCatChip": `CategoryTemplate_subCatChip__CbL14`,
	"attrChip": `CategoryTemplate_attrChip__44Jvt`,
	"actionCell": `CategoryTemplate_actionCell__sM8tv`,
	"subCategorySlot": `CategoryTemplate_subCategorySlot__22zDt`
};
export default ___CSS_LOADER_EXPORT___;
